import { render, staticRenderFns } from "./FileTree.vue?vue&type=template&id=de6d4be4&"
import script from "./FileTree.vue?vue&type=script&lang=js&"
export * from "./FileTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6d4be4')) {
      api.createRecord('de6d4be4', component.options)
    } else {
      api.reload('de6d4be4', component.options)
    }
    module.hot.accept("./FileTree.vue?vue&type=template&id=de6d4be4&", function () {
      api.rerender('de6d4be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/FileTree.vue"
export default component.exports